import api from './axios';

export const getTargets = (month) => api.get('/targets', { params: { month } }).then((r) => r.data);
export const generateTargets = (data) => api.post('/targets/generate', data).then((r) => r.data);
export const copyTargetsFromPrevious = (month) => api.post('/targets/copy-from-previous', { month }).then((r) => r.data);
export const overrideTarget = (id, data) => api.put(`/targets/${id}`, data).then((r) => r.data);
export const resetTargetOverride = (id) => api.delete(`/targets/${id}/override`).then((r) => r.data);
